import React from 'react'
import propTypes from 'prop-types';
import { checkStatus } from '../../shared/facebookOauth'
import { instaStatusCheck } from '../../shared/instagramOauth'
import { fbCheckStatus } from '../../shared/facebookOauthMobile'
import { CMSPath } from '../../../config/constant';
import { twitterOauth, twitterPost } from '../../shared/twitterOauth';
//import { CMSPath } from '../../../config/constant'
export default class ActivityCard extends React.Component {

  facebookProfileData = (methodType) => {
    if (window.cordova) {
      fbCheckStatus(methodType);
    } else {
      checkStatus(methodType);
    }
  }
  postToTwitter = (method) => {
    twitterPost(`we are tweeted on: ${new Date()}`);
    console.log("@@@")
  }

  render() {
    return (
      <div
        id={this.props.id}
        className={`activity-option-items ${this.props.classes}`}
        style={
          this.props.ani === "left" ?
            { transform: 'translate(-415px)', zIndex: this.props.index, width: "-moz-available" } :
            this.props.ani === "right" ?
              { transform: 'translate(415px)', zIndex: this.props.index, width: "-moz-available" } :
              { zIndex: this.props.index, transition: 'all 0s steps(1,end)', width: "-moz-available" }
        }>
        <div className="option-item-img">
          {
            this.props.activity.imageUrl ?
              <img src={`${CMSPath}${this.props.imgBaseUrl}${this.props.activity.imageUrl}`} /> : null
          }
        </div>
        <div className="option-item-desc">
          <span className="title" style={{ color: "inherit" }}>
            {this.props.activity.name}
          </span>
          {this.props.activity.description}
        </div>

        {/*<div className="option-item-soc center">
          <i
            onClick={() => { this.facebookProfileData("post", this.props.activity) }}
            className="fa fa-facebook">
          </i>
          
            <i
              onClick={() => { this.postToTwitter() }}
              className="fa fa-twitter">
            </i>
          
          {/*<i
            onClick={() => { instaStatusCheck("post") }}
            className="fa fa-instagram">
          </i>}
        </div>*/}
      </div>
    )
  }
}

ActivityCard.propTypes = {
  classes: propTypes.string,
  imgBaseUrl: propTypes.string,
  index: propTypes.number,
  activity: propTypes.object,
  id: propTypes.string,
  ani: propTypes.string
}

ActivityCard.defaultProps = {
  classes: "",
  index: 1,
  activity: {},
  id: "",
  ani: "",
  imgBaseUrl: ""
}
